import {Component} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import {SharedService} from '../../shared-service';
import {ToastrService} from 'ngx-toastr';
import {OrganisationManagementService} from '../../../organisation-management/organisation-management.service';

@Component({
  selector: 'app-organisation-selector',
  templateUrl: './organisation-selector.component.html',
  styleUrls: ['./organisation-selector.component.scss']
})
export class OrganisationSelectorComponent {

  currentOrganisation: object = this.sharedService.currentOrganisation;
  organisationsList: any = [{name: 'All', _id: null}];

  constructor(public dialogRef: MatDialogRef<OrganisationSelectorComponent>, private toaster: ToastrService,
              private sharedService: SharedService, private orgMgmtService: OrganisationManagementService) {
    this.getOrganisationsList();
  }

  getOrganisationsList() {
    this.orgMgmtService.getAllOrgs({skip: 0, limit: 0}).subscribe((result: any) => {
      this.organisationsList = this.organisationsList.concat(result.dataList);
    }, error => {
      this.toaster.error('Unable to load the organisation list.');
      this.dialogRef.close(false);
    });
  }

  compareFn(op1, op2) {
    return op1._id === op2._id;
  }

  onDialogClose(from?: string) {
    if (from === 'okBtn') {
      this.dialogRef.close(this.currentOrganisation);
    } else {
      this.dialogRef.close(false);
    }
  }


}
